<!--箱根FP・丹沢大山商材で表示される駅選択UI-->
<template>
  <div>
    <!-- 駅選択Select欄 -->
    <MbFromStationSelect :stations="stations" :setStation="setStation" />

    <!--駅選択に伴う注意文-->
    <MbFromStationCaution
      v-if="
        masterBook.content.description_json &&
        masterBook.content.description_json.MbFromStationCaution
      "
      :note="masterBook.content.description_json.MbFromStationCaution"
    />
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";

import stationService from "@/services/bookBookingStation";

export default {
  name: "TheBbStationSelect",
  props: {
    setStation: {
      type: Function,
      required: true,
    },
    masterBook: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const stations = ref([]);

    onMounted(() => {
      stations.value = stationService.getSelectStationArray(props.masterBook);
      // デフォルト 乗車駅を選択してください をセット
      props.setStation(1);
    });

    return {
      stations,
    };
  },
};
</script>

<style lang="scss" scoped>
.field {
  position: relative;
  margin: 0 0 15px 0;
}
</style>
